<template>
  <div id="contents" class="service-intro">
    <div class="inner">
      <h3 class="main-title">서비스소개</h3>
      <ul class="tab-wrap">
        <li><a href="/service/hometown" class="tab-btn">SKB 우리동네광고</a></li>
        <li><a href="/service/skylife" class="tab-btn">KT스카이라이프 IPTV광고</a></li>
        <li><a href="/service/experience" class="tab-btn">체험단 마케팅</a></li>
        <li><a href="/service/reporter" class="tab-btn">기자단 마케팅</a></li>
        <li><a href="/service/insta" class="tab-btn active">인스타 마케팅</a></li>
        <li><a href="/service/viral" class="tab-btn">바이럴 마케팅</a></li>
      </ul>
    </div>
    <div class="service-intro-wrap intro05">
      <section class="sec01">
        <div class="inner flexbox center">
          <div class="title-wrap">
            <h4 class="section-title">성별 / 지역 / 관심사를 타겟<br>SNS스폰서 마케팅</h4>
            <p class="section-desc">전 세계 20억 명, 국내 2100만 명 이상의 사람들이 사용하고 있는 SNS로 관심사를 타겟으로 하는 세부적인 마케팅입니다.</p>
          </div>
        </div>
      </section>
      <section class="sec02">
        <div class="inner">
          <ul class="list type-btn type-insta">
            <li>
                <span class="round-box">
                  <img src="../resource/images/ico_service_intro14.png" alt=""/>
                  내 뉴스피드에&nbsp;<span class="tx-blue">자연스럽게 노출</span>
                </span>
            </li>
            <li>
                <span class="round-box">
                  <img src="../resource/images/ico_service_intro07.png" alt=""/>
                  연령, 성별, 기기, 지역, 관심사 등&nbsp;<span class="tx-blue">세부적인 고객 타겟팅</span>
                </span>
            </li>
            <li>
                <span class="round-box">
                  <img src="../resource/images/ico_service_intro15.png" alt=""/>
                  데스크탑과 모바일을 동시에&nbsp;<span class="tx-blue">선택하여 홍보 진행 가능</span>
                </span>
            </li>
            <li>
                <span class="round-box">
                  <img src="../resource/images/ico_service_intro16.png" alt=""/>
                  온라인에 뿌려지는&nbsp;<span class="tx-blue">전단지 효과</span>
                </span>
            </li>
          </ul>
        </div>
      </section>
      <section class="sec04">
        <div class="inner small">
          <h4 class="section-sub-title">타겟 예시</h4>
          <div class="flexbox center">
            <img src="../resource/images/service_experience-marketing04.png" alt=""/>
            <img src="../resource/images/service_experience-marketing05.png" alt=""/>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>

export default {
  name: 'page-insta',
  components: {

  },
  data () {
    return {
      curWidth: 2.5
    }
  },
  mounted() {
    if (document.body.clientWidth < 800) {
      this.curWidth = 1
    }
    document.body.classList.add('sub');
    this.scroll();
  },
  methods: {
    scroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || window.screenY;
      document.querySelectorAll("section").forEach(item => {
        if(scrollTop > item.offsetTop - window.innerHeight / this.curWidth){
          item.classList.add("on");
        }
      });
      window.requestAnimationFrame(this.scroll);
    }
  }
}

</script>